import { Box, IconButton, useTheme } from "@mui/material";
import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export default function NavigateTabBtn({
  handleChange,
  type,
  selectedTab,
  maxLength,
}) {
  const theme = useTheme();
  return (
    <Box
      display={
        type == "left"
          ? selectedTab >= maxLength - 1
            ? "none"
            : "flex"
          : selectedTab == 0
          ? "none"
          : "flex"
      }
      onClick={() => handleChange(type)}
      left={type == "left" ? "0%" : "100%"}
      sx={{
        zIndex: "100",
        top: "50%",
        position: "absolute",
        width: { xs: "30px", md: "50px" },
        height: { xs: "30px", md: "50px" },
        cursor: "pointer",
        transform: `translateX(${type == "left" ? "0px" : "-100%"})`,
        
      }}
    >
      <IconButton sx={{color: theme.palette.primary.main,}}>
        {type == "left" ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
    </Box>
  );
}
